<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Cabang</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm" >
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA CABANG</h6>
                    <b-form-group label="Kode Cabang">
                        <b-form-input v-model="input.kodeCabang" name="kodeCabang" :state="kodeCabangState" :maxlength="4" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Nama Cabang">
                        <b-form-input v-model="input.namaCabang" name="namaCabang" type="text" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Status cabang">
                        <b-form-select v-model="input.isActive" name="statusCabang" value-field="value" text-field="name" required> 
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Pilih status</b-form-select-option>
                                <b-form-select-option :value="true">Buka</b-form-select-option>
                                <b-form-select-option :value="false" >Tutup</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Kelas Cabang">
                        <b-form-select v-model="input.kelasCabang" name="kelasCabang" :options="kelasCabangOption" value-field="id" text-field="name" required> 
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Pilih kelas cabang</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Jenis Cabang">
                        <b-form-select v-model="input.isKcu" name="jenisCabang">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Pilih jenis cabang</b-form-select-option>
                                <b-form-select-option :value="1">KCU</b-form-select-option>
                                <b-form-select-option :value="0">KCP</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="No.Telp Cabang">
                        <b-form-input v-model="input.noTelpCabang" name="noTelpCabang"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Kota Cabang">
                        <div class="d-flex">
                            <multiselect
                                name="kotaCabang"
                                v-model="input.kotaCabang" 
                                :options="kota" 
                                :internal-search="false"
                                :loading="isLoadingKota"
                                @search-change="searchKota"
                                :allow-empty="false"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="*Ketik min. 4 huruf untuk mencari..."
                            />
                        </div>
                    </b-form-group>
                    <b-form-group label="Nama di Banner">
                        <b-form-input v-model="input.namaBanner" name="namaBanner" type="text"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Alamat Cabang">
                        <b-form-textarea v-model="input.alamatCabang" name="alamatCabang" rows="3" required></b-form-textarea>
                    </b-form-group>
					<b-form-group label="Latitude">
						<b-form-input v-model="input.latitude" max="15" name="latitude"></b-form-input>
						<span class="smallText text-muted">
							Latitude cabang (sebagai contoh, -82.28182)
						</span>
					</b-form-group>
					<b-form-group label="Longitude">
						<b-form-input v-model="input.longitude" max="15" name="longitude"></b-form-input>
						<span class="smallText text-muted">
							Longitude cabang (sebagai contoh, 12.99782)
						</span>
					</b-form-group>
					<b-form-group label="Alamat IP Cabang">
						<b-form-input v-model="input.ipAddress" max="20" name="ipAddress"></b-form-input>
						<span class="smallText text-muted">
							Alamat IP untuk WiFi pada cabang (Digunakan untuk pengecekan akses user). Contoh: 36.121.33.211
						</span>
					</b-form-group>
                    <b-form-group label="Tanggal Operasional">
                        <b-form-input
                            v-model="input.operationalDate"
                            name="operationalDate"
                            id="operationalDate"
                            type="date"
                            class="flex-fill"
                        ></b-form-input>
                    </b-form-group>
                    <b-row no-gutters class="pt-2">
                        <b-col cols="7" sm="3" xl="2">
                            Gadai Emas
                        </b-col>
                        <b-col cols="1">
                            <b-form-checkbox id="gadaiEmas" v-model="input.gadaiEmas" name="gadaiEmas" value="true" unchecked-value="false">
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <div class="smallText text-muted">
                        Checklist untuk mengaktifkan Gadai Emas
                    </div>

                    <b-row no-gutters class="pt-2">
                        <b-col cols="7" sm="3" xl="2">
                            Biaya Asuransi
                        </b-col>
                        <b-col cols="1">
                            <b-form-checkbox id="biayaAdmin" v-model="input.isUsingAdminFee" name="biayaAdmin" value="true" unchecked-value="false">
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <div class="smallText text-muted">
                        Checklist untuk mengaktifkan Biaya Asuransi
                    </div>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PIC</h6>
                    <b-form-group label="Kepala Unit">
                        <div class="d-flex">
                            <b-input-group>
                                <b-form-select v-if="kuLoading == true" v-model="data" name="kepalaUnit" disabled>
                                    <template v-slot:first>
                                        <b-form-select-option value="null" disabled>Mengambil data ...</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-form-select v-else v-model="input.kepalaUnit" name="kepalaUnit" :options="ku" value-field="id" text-field="name">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-input-group-append v-if="kuLoadingFail == true">
                                    <b-button variant="primary" size="sm" @click="loadKU"><i class="fa fa-refresh"></i></b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <b-button class="ml-2" variant="danger" name="removeKU" @click="onRemoveKU">Hapus</b-button>
                        </div>
                    </b-form-group>
                    <b-form-group label="Kepala Cabang">
                        <div class="d-flex">
                            <multiselect
                                name="kepalaCabang"
                                v-model="input.kepalaCabang" 
                                :options="staffKC" 
                                :internal-search="false"
                                :loading="isLoadingKC"
                                @search-change="searchKC"
                                :allow-empty="false"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="*Ketik min. 4 huruf untuk mencari..."
                            />
                            <b-button class="ml-2" variant="danger" name="removeKC" @click="onRemoveKC">Hapus</b-button>
                        </div>
                    </b-form-group>
                    <b-form-group label="Area Manager">
                        <div class="d-flex">
                            <multiselect
                                name="kepalaCabangSenior"
                                v-model="input.kepalaCabangSenior" 
                                :options="staffKCS" 
                                :internal-search="false"
                                :loading="isLoadingKCS"
                                @search-change="searchKCS"
                                :allow-empty="false"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="*Ketik min. 4 huruf untuk mencari..."
                            />
                            <b-button class="ml-2" variant="danger" name="removeKCS" @click="onRemoveKCS">Hapus</b-button>
                        </div>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="cabangSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Cabang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah cabang ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'edit-cabang',
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isLoadingKota: false,
            kuLoading: false,
            data: null,
            isLoadingKC: false,
            isLoadingKCS: false,
            activeSearchKota: null,
            kuLoadingFail: false,
            activeSearchKC: null,
            activeSearchKCS: null,
            kota: [],
            ku: [],
            staffKC: [],
            staffKCS: [],
            kodeCabangState: null,
            cabang: {},
            input:{
                kodeCabang: null,
                namaCabang: "",
                alamatCabang: "",
                kotaCabang: {},
				noTelpCabang: null,
				latitude: null,
				longitude: null,
				ipAddress: null,
                kepalaUnit: null,
                kepalaCabang: { id: null, name:null },
                kepalaCabangSenior: { id: null, name:null },
                gadaiEmas:false,
                isUsingAdminFee:false,
                isActive: false,
                kelasCabang: null,
                isKcu: null,
                namaBanner: '',
                operationalDate: null,
            },
            kelasCabangOption: [
                { id: 1, name: 'Kelas 1'},
                { id: 2, name: 'Kelas 2'},
                { id: 3, name: 'Kelas 3'}
            ],
            kepalaUnit: [],  
            kepalaCabang: [],  
            kepalaCabangSenior: []
        }
    },

    methods:{


        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id
            this.kuLoading = true

            let getSingleCabang = this.$axios.get(`cabang/${this.id}`).then(response => {
                this.cabang = response.data
                //----------------- Inisialisasi Data Cabang -----------------

                this.input.kodeCabang = this.cabang.kode
                this.input.namaCabang = this.cabang.name
                this.input.alamatCabang = this.cabang.alamat
                this.input.kotaCabang = this.cabang.kota
				this.input.noTelpCabang = this.cabang.noTelp
				this.input.latitude = this.cabang.latitude
				this.input.longitude = this.cabang.longitude
				this.input.ipAddress = this.cabang.ipAddress
                this.input.gadaiEmas = this.cabang.gadaiEmasActive
                this.input.isUsingAdminFee = this.cabang.isUsingAdminFee
                this.input.isActive = this.cabang.isActive
                this.input.kelasCabang = this.cabang.branchClass
                this.input.isKcu = this.normalizeIsKcu(this.cabang.isKcu)
                this.input.namaBanner = this.cabang.bannerName
                this.input.operationalDate = this.cabang.operationalDate

                this.$axios.get(`cabang/staffs/${this.id}`).then(response => {
                    this.ku = response.data
                    this.kuLoading = false
                    
                    if(this.cabang.ku != null){
                        this.input.kepalaUnit = this.cabang.ku.id
                    }
                    if(this.cabang.kc != null){
                        this.input.kepalaCabang.id = this.cabang.kc.id
                        this.input.kepalaCabang.name = this.cabang.kc.fullname
                    }
                    if(this.cabang.kcs != null){
                        this.input.kepalaCabangSenior.id = this.cabang.kcs.id
                        this.input.kepalaCabangSenior.name = this.cabang.kcs.fullname
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.kuLoading = false
                    this.kuLoadingFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })

            })

            getSingleCabang.then(() => {
                this.initStatus = 1
 
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Cari Kota -----------------

        searchKota(searchQuery){
            if (searchQuery.length >= 4){
                this.isLoadingKota = true

                if (this.activeSearchKota == null) this.activeSearchKota = setTimeout(() => { this.searchKotaFunc(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearchKota)
                    this.activeSearchKota = setTimeout(() => { this.searchKotaFunc(searchQuery) }, 1000)
                }
            } 
            else {
                clearTimeout(this.activeSearchKota)
                this.activeSearchKota = null
                this.isLoadingKota = false
            }
        },
        
        searchKotaFunc(searchQuery){
            this.$axios.get('area/search/kota/?name='+searchQuery).then(response => {
                this.kota = response.data
                this.isLoadingKota = false
                this.activeSearchKota = null
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },


        //----------------- Fungsi Cari Staff -----------------

        loadKU(){
            this.kuLoading = true
            this.kuLoadingFail = false

            this.$axios.get(`cabang/staffs/${this.id}`).then(response => {
                this.ku = response.data
                this.kuLoading = false
                
                if(this.cabang.ku != null){
                    this.input.kepalaUnit = this.cabang.ku.id
                }
                if(this.cabang.kc != null){
                    this.input.kepalaCabang.id = this.cabang.kc.id
                    this.input.kepalaCabang.name = this.cabang.kc.fullname
                }
                if(this.cabang.kcs != null){
                    this.input.kepalaCabangSenior.id = this.cabang.kcs.id
                    this.input.kepalaCabangSenior.name = this.cabang.kcs.fullname
                }
            })
            .catch(error => {
                console.log(error)
                this.kuLoading = false
                this.kuLoadingFail = true

                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },

        searchKC(searchQuery){
            if (searchQuery.length >= 4){
                this.isLoadingKC = true

                if (this.activeSearchKC == null) this.activeSearchKC = setTimeout(() => { this.searchKCFunc(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearchKC)
                    this.activeSearchKC = setTimeout(() => { this.searchKCFunc(searchQuery) }, 1000)
                }
            } 
            else {
                clearTimeout(this.activeSearchKC)
                this.activeSearchKC = null
                this.isLoadingKC = false
            }
        },

        searchKCFunc(searchQuery){
            this.$axios.get('user/search/?fullname='+searchQuery).then(response => {
                this.staffKC = response.data
                this.isLoadingKC = false
                this.activeSearchKC = null
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },

        searchKCS(searchQuery){
            if (searchQuery.length >= 4){
                this.isLoadingKCS = true

                if (this.activeSearchKCS == null) this.activeSearchKCS = setTimeout(() => { this.searchKCSFunc(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearchKCS)
                    this.activeSearchKCS = setTimeout(() => { this.searchKCSFunc(searchQuery) }, 1000)
                }
            } 
            else {
                clearTimeout(this.activeSearchKCS)
                this.activeSearchKCS = null
                this.isLoadingKCS = false
            }
        },

        searchKCSFunc(searchQuery){
            this.$axios.get('user/search/?fullname='+searchQuery).then(response => {
                this.staffKCS = response.data
                this.isLoadingKCS = false
                this.activeSearchKCS = null
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },
        

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()

            //----------------- Append Data Cabang -----------------

            payload.append("kode", this.input.kodeCabang)
            payload.append("name", this.input.namaCabang)
            payload.append("alamat", this.input.alamatCabang)
            payload.append("kotaId", this.input.kotaCabang.id)
            payload.append("gadaiEmasActive", this.input.gadaiEmas)
            payload.append("isUsingAdminFee", this.input.isUsingAdminFee)
            payload.append("isActive", this.input.isActive)
            payload.append("bannerName", this.input.namaBanner)
            payload.append("branchClass", this.input.kelasCabang)
            if(this.input.isKcu !== null && this.input.isKcu !== undefined) payload.append("isKcu", this.input.isKcu)
            payload.append("skemaPerhitungan", 2)
			if(this.$helper.isNotNullAndNotEmpty(this.input.operationalDate)) payload.append("operationalDate", this.input.operationalDate)

            payload.append("cashVirtualActive", false)
            if (this.$helper.isNotNullAndNotEmpty(this.input.noTelpCabang)) payload.append("telepon", this.input.noTelpCabang)
			
			if(this.$helper.isNotNullAndNotEmpty(this.input.latitude)) payload.append("latitude", this.input.latitude)
			if(this.$helper.isNotNullAndNotEmpty(this.input.longitude)) payload.append("longitude", this.input.longitude)
			if(this.$helper.isNotNullAndNotEmpty(this.input.ipAddress)) payload.append("ipAddress", this.input.ipAddress)
			
			
            if(this.input.kepalaUnit != null) payload.append("kuId", this.input.kepalaUnit)
            if(this.input.kepalaCabang.id != null) payload.append("kcId", this.input.kepalaCabang.id)
            if(this.input.kepalaCabangSenior.id != null) payload.append("kcsId", this.input.kepalaCabangSenior.id)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post(`cabang/${this.id}`, payload).then(response => {
                this.initStatus = 1
                this.$helper.setFlash(`Cabang telah berhasil diubah!`)
                
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },


        //----------------- Fungsi Lain -----------------

        normalizeIsKcu(value) {
            if (value === null || value === undefined || value === '') return null
            return Number(value)
        },

        onRemoveKU(){
            this.input.kepalaUnit = null
        },

        onRemoveKC(){
            this.input.kepalaCabang = { id: null, name: null }
        },

        onRemoveKCS(){
            this.input.kepalaCabangSenior = { id: null, name: null }
        },

        openModalConfirm(){
            if (!this.validKodeCabang(this.input.kodeCabang) || !(this.input.kodeCabang.length ==4)) {
                this.$helper.toastErr(this, "Kode cabang harus 4 karakter, hanya huruf dan angka.")
                this.kodeCabangState = false;
            } 
            else if (this.input.kotaCabang == null) {
                this.$helper.toastErr(this, "Pilih kota cabang terlebih dahulu.")
            }else if(this.$helper.isNullOrEmpty(this.input.kodeCabang) || this.$helper.isNullOrEmpty(this.input.namaCabang) || this.$helper.isNullOrEmpty(this.input.alamatCabang) || this.$helper.isNullOrEmpty(this.input.noTelpCabang)) {
                this.$helper.toastErr(this, "Kode, nama, alamat, dan no. telp cabang wajib diisi.")
            }else if(this.$helper.isNotNullAndNotEmpty(this.input.latitude) && this.input.latitude.length >15){
				this.$helper.toastErr(this, "Latitude tidak boleh lebih dari 15 karakter.")
			}else if(this.$helper.isNotNullAndNotEmpty(this.input.longitude) && this.input.longitude.length > 15){
				this.$helper.toastErr(this, "Longitude tidak boleh lebih dari 15 karakter.")
			}else if(this.$helper.isNotNullAndNotEmpty(this.input.ipAddress) && this.input.ipAddress.length> 20){
				this.$helper.toastErr(this, "Alamat IP cabang tidak boleh lebih dari 20 karakter.")
			}
            else {
                this.kodeCabangState = true;
                this.$bvModal.show("modal-confirm-edit")
            }
        },

        validKodeCabang(kodeCabang){
            var re = /^[0-9a-zA-Z]+$/;
            return re.test(kodeCabang);
        }

    },

    created(){
        this.init()
    }
}
</script>
